module.exports = __webpack_public_path__ + "static/assets/50d9f9d7f92866432cbc9ea49e0cfdc1.svg";